.row {
  display: flex;
  align-items: center;
  margin: 6px 20px 6px 5px;
}
